<div *ngIf="notification" 
    [class.animate__fadeOut]="hide"
    [class]="notificationStylesType"
    class="animate__animated animate__backInRight animate__faster border-t-4 rounded-b px-4 py-3 shadow-md mb-3 min-w-96"
    role="alert">
    <div class="flex">
        <div class="py-1">
            <i class="fill-current text-2xl mr-4 fa-solid" [class]="notificationIconType"></i>
        </div>
        <div>
            <p class="font-bold">{{ notification.title }}</p>
            <p class="text-sm whitespace-pre">{{ notification.message }}</p>
        </div>
    </div>
</div>